import { Pipe, PipeTransform } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { UserData } from "../../providers/user";

@Pipe({ name: "quantityUser" })
export class UserCheckDataPipe implements PipeTransform {

    constructor(
        private userData: UserData,
    ) { }

    public transform(value: string, clientId: string) {
        if (!value) { return Observable.of([]); }
        return this.userData.getUserQuantity(value, clientId);
    }
}



// WEBPACK FOOTER //
// ./src/pipes/user/user-check.ts